import { z } from 'zod'

/** 企業名稱資料 Schema */
export const corporateNameSchema = z.object({
  /** BIZ_ID */
  bizId: z.string(),
  /** 客戶名稱[英文] */
  englishName: z.string(),
  /** 客戶名稱[當地語系] */
  localName: z.string()
})

/** 企業名稱資料 */
export interface CorporateName extends z.infer<typeof corporateNameSchema> {}
